export default href => {
  return Object.assign({}, ...(
    (href.includes('?') ? href : '?')
    .split('?')[1]
    .split('&')
    .map(param => param.split('='))
    .map(item => ({ [item[0]]: item[1] }))
  ));
};
